module.exports = __webpack_public_path__ + "static/media/loading.79c543bf.svg";